import { render } from "./Manage_2.vue?vue&type=template&id=629aa58c&scoped=true"
import script from "./Manage_2.vue?vue&type=script&lang=js"
export * from "./Manage_2.vue?vue&type=script&lang=js"

import "./Manage_2.vue?vue&type=style&index=0&id=629aa58c&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629aa58c"]])

export default __exports__